<div class="title">
    <title-back [addTitle]="true" [Title]="''" (back)="previousPage()"></title-back>
</div>
<button mat-raised-button (click)="add()">Add More Items</button>
<ng-container>
    <div class="teamTable setTable">
        <mat-table matSort [dataSource]="dataSource" (matSortChange)="announceSortChange($event)">
            <ng-container matColumnDef="container_number">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Component Code </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <!-- <span class="depotName">{{element.container_number}}</span> -->
                    <app-mat-auto-search [isEditable]="true" [displayField]="'name'" [setSearchValue]="false"
                        [masterDashboard]="true" [name]="'name'" placeholder="Search by Depot Name" [idField]="null"
                        [listUrl]="mnr_url+'?search=::search::'">
                    </app-mat-auto-search>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="container_size_type">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Location Code </mat-header-cell>
                <mat-cell *matCellDef="let element" class="fs-13">
                    <!-- {{element.container_size_type?.display_name}} -->
                    <app-mat-auto-search [isEditable]="true" [displayField]="'name'" [setSearchValue]="false"
                        [masterDashboard]="true" [name]="'name'" placeholder="Search by Depot Name" [idField]="null"
                        [listUrl]="mnr_url+'?search=::search::'">
                    </app-mat-auto-search>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="condition">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Damaged Code </mat-header-cell>
                <mat-cell *matCellDef="let element" class="fs-13">
                    <!-- {{element.condition?.value}} -->
                    <app-mat-auto-search [isEditable]="true" [displayField]="'name'" [setSearchValue]="false"
                        [masterDashboard]="true" [name]="'name'" placeholder="Search by Depot Name" [idField]="null"
                        [listUrl]="mnr_url+'?search=::search::'">
                    </app-mat-auto-search>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="address">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Repair Code </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <!-- <span class="addresses ">{{element.address ?? '-'}}</span> -->
                    <app-mat-auto-search [isEditable]="true" [displayField]="'name'" [setSearchValue]="false"
                        [masterDashboard]="true" [name]="'name'" placeholder="Search by Depot Name" [idField]="null"
                        [listUrl]="mnr_url+'?search=::search::'">
                    </app-mat-auto-search>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="csc_plate_number">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Description </mat-header-cell>
                <mat-cell *matCellDef="let element" class="fs-13">
                    {{element.csc_plate_number ?? '-'}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="csc_expiry_date">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Unit of Measurement </mat-header-cell>
                <mat-cell *matCellDef="let element" class="fs-13">
                    {{(element.csc_expiry_date | date:'dd MMM, yyyy')?? '-'}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="primary_port2">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Unit Measure </mat-header-cell>
                <mat-cell *matCellDef="let element" class="fs-13">
                    {{element.primary_port?.port?.name_display ?? '-'}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="mnr_status">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Units Required </mat-header-cell>
                <mat-cell *matCellDef="let element" class="fs-13">
                    {{element.mnr_status?.value ?? '-'}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="isEdit">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Per Unit Cost </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <div class="actions">
                        <i class="flaticon-view"></i>
                    </div>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="isEdit1">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Labour Charge </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <div class="actions">
                        <i class="flaticon-view"></i>
                    </div>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="isEdit2">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Time Required </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <div class="actions">
                        <i class="flaticon-view"></i>
                    </div>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="isEdit3">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Total </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <div class="actions">
                        <i class="flaticon-view"></i>
                    </div>
                </mat-cell>
            </ng-container>
            <mat-header-row class="header-row" *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" [class.blur]="update"></mat-row>
        </mat-table>
    </div>
    <button mat-raised-button>Save Repair Estimate</button>
    <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10" aria-label="Select page of Charges"
        [length]="pageLength" (page)="pageChanged($event)">
    </mat-paginator> -->
</ng-container>